/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export enum ANIMATION_TYPE {
  /**
   * Animation that slides targeted content to the top.
   */
  SLIDE_UP = 'slide-up',

  /**
   * Animation that slides targeted content to the top right.
   */
  SLIDE_UP_RIGHT = 'slide-up-right',

  /**
   * Animation that slides targeted content to the right.
   */

  SLIDE_RIGHT = 'slide-right',

  /**
   * Animation that slides targeted content to the bottom right.
   */

  SLIDE_DOWN_RIGHT = 'slide-down-right',

  /**
   * Animation that slides targeted content to the bottom.
   */

  SLIDE_DOWN = 'slide-down',

  /**
   * Animation that slides targeted content to the bottom left.
   */

  SLIDE_DOWN_LEFT = 'slide-down-left',

  /**
   * Animation that slides targeted content to the left.
   */

  SLIDE_LEFT = 'slide-left',

  /**
   * Animation that slides targeted content to the top left.
   */

  SLIDE_UP_LEFT = 'slide-up-left',

  FADE = 'fade',
}
